<div class="reasoning-group">
    <div *ngFor="let item of items" class="reasoning-item">
        <app-reasoning
            [reasoningType]="item.reasoningType"
            [title]="item.title"
            [guidelines]="item.guidelines"
            [placeholder]="item.placeholder"
        ></app-reasoning>
    </div>
</div>
